import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=5664f7b0&scoped=true"
import script from "./address-info.vue?vue&type=script&lang=ts"
export * from "./address-info.vue?vue&type=script&lang=ts"
import style0 from "./address-info.vue?vue&type=style&index=0&id=5664f7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664f7b0",
  null
  
)

export default component.exports